import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

import {
  IconUsedVacations,
  IconRemainingVacations,
} from "../../common/icons";
import { LoadingContainer } from "../../common/loaders/loadingcontainer";
import { useGetCurrentUserPerson } from "../../api/endpoints";
import { vacationBalancesYearlyGetPerson } from "../../api";

const STORAGE_KEY = "personal_vacation_selected_year";

export function PersonalVacationDays() {
  const { t } = useTranslation();

  const { data: user, isLoading: userLoading } = useGetCurrentUserPerson();
  const personId = user?.personId;

  const [apiData, setApiData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!personId) return;

    let active = true;

    const load = async () => {
      try {
        setLoading(true);

        const res = await vacationBalancesYearlyGetPerson(personId);
        const list = res?.data ?? [];

        if (!active) return;

        setApiData(list);

        const years = [...new Set(list.map(x => x.annualVacationYear))]
          .sort()
          .reverse();

        const saved = localStorage.getItem(STORAGE_KEY);

        const initialYear =
          saved && years.includes(saved)
            ? saved
            : years[0] ?? null;

        setSelectedYear(initialYear);
      } finally {
        if (active) setLoading(false);
      }
    };

    load();

    return () => {
      active = false;
    };
  }, [personId]);

  useEffect(() => {
    if (selectedYear) {
      localStorage.setItem(STORAGE_KEY, selectedYear);
    }
  }, [selectedYear]);

  const years = [...new Set(apiData.map(x => x.annualVacationYear))]
    .sort()
    .reverse();

  const selected = apiData.find(
    x => x.annualVacationYear === selectedYear
  );

  if (userLoading || loading || !personId) {
    return <LoadingContainer />;
  }

  const allowance = Number(selected?.vacationAllowanceDays ?? 0);
  const used = Number(selected?.usedVacationDays ?? 0);
  const remaining = Math.max(0, allowance - used);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h4 style={{ color: "var(--heeros-blue)" }}>
          {t("VacationDays", "Lomapäivät")}
        </h4>

        <select
          value={selectedYear ?? ""}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          {years.map(year => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      <Row className="text-center mt-4-5">
        <Col>
          <IconRemainingVacations />
          <div className="vacation-label">
            {t("RemainingVacationDays", "Lomapäiviä jäljellä")}
          </div>
          <h2 className="vacation-value">{remaining}</h2>
        </Col>

        <Col>
          <IconUsedVacations />
          <div className="vacation-label">
            {t("UsedVacationDays", "Lomapäiviä käytetty")}
          </div>
          <h2 className="vacation-value">{used}</h2>
        </Col>
      </Row>
    </>
  );
}